import { useLocation, useNavigate } from 'react-router-dom';
import {
  Header,
  Label,
  Icon,
  Loader,
  Table,
  Segment,
  Grid,
  Pagination,
  Button,
  Container,
} from 'semantic-ui-react';
import React, { useState } from 'react';

import moment from 'moment';
import { PAGE_SIZE } from '../../constants';
import EvaluationCriterionCard from './EvaluationCriterionCard';
import { useGetEvaluationCriteriaGroupsQuery } from './evaluationCriteriaGroupApiSlice';

const EvaluationCriteriaGroupList = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [selectedCriteriaGroup, setSelectedCriteriaGroup] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get('page');
  const page_size = queryParams.get('page_size');

  // get query params from frontend url -> remove null ones to pass to backend
  let qp = { page, page_size };

  // get evaluation criteria groups
  const { data, isLoading, isSuccess, isError, error } =
    useGetEvaluationCriteriaGroupsQuery({ ...qp });

  // handle the action for selecting criteria group
  const handleSelectGroup = criteria_group => {
    setSelectedCriteriaGroup(criteria_group);
  };

  const handlePaginationChange = (e, { activePage }) => {
    let url = `/evaluationcriteriagrouplist?page=${activePage}&page_size=${PAGE_SIZE}`;
    navigate(url);
  };

  let content;
  if (isLoading) {
    content = <Loader active />;
  } else if (isSuccess) {
    content = (
      <div
        style={{
          // backgroundColor: '#f9fafb',
          // minHeight: '100vh',
          height: 'auto',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {/* Header Section */}
        <div
          style={{
            flex: '0 0 auto',
            padding: '16px 0',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(20px)',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
          }}
        >
          <Container fluid>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '0 20px',
              }}
            >
              <div
                style={{
                  width: '40px',
                  flexShrink: 0, // stays a circle when the text beside it wraps
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#F2F2F7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Icon
                  name="tasks"
                  style={{ margin: 0, color: '#007AFF', fontSize: '18px' }}
                />
              </div>
              <div>
                <h2
                  style={{
                    fontSize: '17px',
                    fontWeight: '600',
                    margin: 0,
                    color: '#1d1d1f',
                  }}
                >
                  평가 항목 그룹
                </h2>
                <p style={{ fontSize: '13px', color: '#86868b', margin: 0 }}>
                  평가 항목 관리
                </p>
              </div>
            </div>
          </Container>
        </div>

        <Container
          fluid
          style={{
            padding: '20px',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <Grid style={{  margin: 0 }} container={false}>
            {/* Left Pane: Table */}
            <Grid.Column width={8} style={{ paddingBottom: 0 }}>
              <div
                style={{ 
                  display: 'flex', 
                  flexDirection: 'column',
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,0,0,0.05)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  overflowY: 'auto',
                  // maxHeight: '100%',
                }}
              >
                <div>
                  <Table
                    compact="very"

                    selectable
                    style={{ margin: 0, border: 'none' }}
                  >
                    <Table.Header style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: 'white' }}>
                      <Table.Row >
                        <Table.HeaderCell style={{ borderBottom: '1px solid rgba(34,36,38,.15)' }}>ID</Table.HeaderCell>
                        <Table.HeaderCell style={{ borderBottom: '1px solid rgba(34,36,38,.15)' }}>그룹 이름</Table.HeaderCell>
                        <Table.HeaderCell style={{ borderBottom: '1px solid rgba(34,36,38,.15)' }}>생성일</Table.HeaderCell>
                        <Table.HeaderCell style={{ borderBottom: '1px solid rgba(34,36,38,.15)' }}>설명</Table.HeaderCell>
                        <Table.HeaderCell style={{ borderBottom: '1px solid rgba(34,36,38,.15)' }}>항목 수</Table.HeaderCell>
                        {/* <Table.HeaderCell width={2} style={{ borderBottom: '1px solid rgba(34,36,38,.15)' }}>상세 보기</Table.HeaderCell> */}
                      </Table.Row>
                    </Table.Header>

                  <Table.Body>
                    {data.results.map((criteria_group, i) => (
                      <Table.Row
                        // textAlign="center"
                        key={criteria_group.id}
                        active={
                          selectedCriteriaGroup &&
                          selectedCriteriaGroup.id === criteria_group.id
                        }
                        onClick={() => handleSelectGroup(criteria_group)}
                        style={{ cursor: 'pointer' }}
                      >
                        <Table.Cell>
                          <Label
                            circular
                            color={
                              selectedCriteriaGroup &&
                              selectedCriteriaGroup.id === criteria_group.id
                                ? 'blue'
                                : undefined
                            }
                            onClick={(e) => {
                              // e.stopPropagation();
                              navigator.clipboard.writeText('criteria group id:' + criteria_group.id);
                            }}
                            style={{ cursor: 'pointer' }}
                            title="Click to copy ID"
                          >
                            {criteria_group.id.slice(0, 5)}
                          </Label>
                        </Table.Cell>
                        <Table.Cell>{criteria_group.name}</Table.Cell>

                        <Table.Cell>
                          {moment(criteria_group.created_at).format('YYYY-MM-DD')}
                        </Table.Cell>
                        <Table.Cell> {criteria_group.info.description}</Table.Cell>
                        <Table.Cell><Label basic>{criteria_group.criteria.length}</Label></Table.Cell>
                        
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
                </div>

                {/* Pagination inside Left Pane */}
                <div style={{ 
                  padding: '12px', 
                  borderTop: '1px solid rgba(0,0,0,0.05)', 
                  display: 'flex', 
                  justifyContent: 'center',
                  backgroundColor: '#f8f9fa'
                }}>
                  <Pagination
                    activePage={page}
                    onPageChange={handlePaginationChange}
                    totalPages={Math.ceil(data.count / page_size)}
                    size="mini"
                    ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                    firstItem={{ content: <Icon name="angle double left" />, icon: true }}
                    lastItem={{ content: <Icon name="angle double right" />, icon: true }}
                    prevItem={{ content: <Icon name="angle left" />, icon: true }}
                    nextItem={{ content: <Icon name="angle right" />, icon: true }}
                  />
                </div>
              </div>
            </Grid.Column>

            {/* Right Pane: Detail */}
            <Grid.Column width={8} style={{ height: '100%', paddingBottom: 0 }}>
              <div
                style={{
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,0,0,0.05)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  position: 'relative',
                  overflow: 'hidden',
                  height: 'calc(100vh - 200px)',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    overflowY: 'auto',
                    padding: '1rem',
                  }}
                >
                  {selectedCriteriaGroup ? (
                    selectedCriteriaGroup.criteria.map((criterion, index) => (
                      <EvaluationCriterionCard
                        key={criterion.id}
                        criterion={criterion}
                        index={index}
                      />
                    ))
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        color: '#86868b',
                      }}
                    >
                      <Icon
                        name="hand point left outline"
                        size="huge"
                        style={{ marginBottom: '1rem' }}
                      />
                      <p>왼쪽 목록에서 그룹을 선택하여 평가 항목을 확인하세요.</p>
                    </div>
                  )}
                </div>
              </div>
            </Grid.Column>
          </Grid>
        </Container>
      </div>
    );
  } else if (isError) {
    content = null;
  }

  return content;
};
export default EvaluationCriteriaGroupList;
